import React from 'react';

const LABELS = {
  ACTIVE: { label: 'Aktif', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  PENDING: { label: 'Menunggu Verifikasi', cls: 'bg-amber-100 text-amber-800 border-amber-200' },
  SUBMITTED: { label: 'Bukti Terkirim', cls: 'bg-sky-100 text-sky-800 border-sky-200' },
  APPROVED: { label: 'Disetujui', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  REJECTED: { label: 'Ditolak', cls: 'bg-red-100 text-red-800 border-red-200' },
  EXPIRED: { label: 'Berakhir', cls: 'bg-slate-100 text-slate-700 border-slate-200' },
  SUSPENDED: { label: 'Ditangguhkan', cls: 'bg-orange-100 text-orange-800 border-orange-200' },
  CANCELLED: { label: 'Dibatalkan', cls: 'bg-slate-100 text-slate-700 border-slate-200' },
  PAID: { label: 'Dibayar', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  AVAILABLE: { label: 'Tersedia', cls: 'bg-teal-100 text-teal-800 border-teal-200' },
  HELD: { label: 'Ditahan', cls: 'bg-amber-100 text-amber-800 border-amber-200' },
  OPEN: { label: 'Terbuka', cls: 'bg-red-100 text-red-800 border-red-200' },
  RESOLVED: { label: 'Selesai', cls: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  REVIEWED: { label: 'Ditinjau', cls: 'bg-sky-100 text-sky-800 border-sky-200' },
  DISMISSED: { label: 'Diabaikan', cls: 'bg-slate-100 text-slate-700 border-slate-200' },
  LOW: { label: 'LOW', cls: 'bg-slate-100 text-slate-700 border-slate-200' },
  MEDIUM: { label: 'MEDIUM', cls: 'bg-amber-100 text-amber-800 border-amber-200' },
  HIGH: { label: 'HIGH', cls: 'bg-orange-100 text-orange-800 border-orange-200' },
  CRITICAL: { label: 'CRITICAL', cls: 'bg-red-100 text-red-800 border-red-200' },
};

export const StatusBadge = ({ status, testid }) => {
  const s = LABELS[status] || { label: status || '-', cls: 'bg-slate-100 text-slate-700 border-slate-200' };
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />{s.label}
    </span>
  );
};

export default StatusBadge;
